import axiosApi from '@/api/axiosApi';

export const save = (data) => {
    return axiosApi({
        url: '/intserv/reseller/save',
        method: 'post',
        data
    })
}